import LegalPage from "../../components/LegalPage";

export default function CGV() {
  return (
    <LegalPage
      title="Conditions Générales de Vente"
      kicker="CGV"
      lastUpdated="08 juillet 2026"
      hideDraftNotice
    >
      <h2>1. Objet</h2>
      <p>
        Les présentes Conditions Générales de Vente, ci-après les «&nbsp;CGV&nbsp;»,
        ont pour objet de définir les conditions dans lesquelles OTRA GAMING
        propose à la vente des codes de participation, accès à des quiz,
        défis, Golden Quizz, événements live et services associés sur la
        plateforme OTRAQUIZZ, accessible à l&apos;adresse&nbsp;:{" "}
        <a href="https://otra-gaming.fr" target="_blank" rel="noreferrer">https://otra-gaming.fr</a>.
      </p>
      <p>
        Les présentes CGV s&apos;appliquent à toute commande passée par un
        utilisateur consommateur sur le site OTRAQUIZZ. Toute commande
        implique l&apos;acceptation pleine et entière des présentes CGV.
      </p>

      <h2>2. Vendeur</h2>
      <p>Le site OTRAQUIZZ est édité et exploité par&nbsp;:</p>
      <p>
        <strong>OTRA GAMING</strong><br />
        Exploité par Jérôme HAGUETTE<br />
        SIRET&nbsp;: 508 788 569 00046<br />
        Adresse&nbsp;: 16 rue Hyacinthe Rigaud, 66680 Canohès<br />
        Email de contact&nbsp;: <a href="mailto:otragaming@outlook.fr">otragaming@outlook.fr</a>
      </p>
      <p>
        Ci-après désigné «&nbsp;OTRA GAMING&nbsp;», «&nbsp;OTRAQUIZZ&nbsp;»,
        «&nbsp;le Vendeur&nbsp;», «&nbsp;l&apos;Éditeur&nbsp;» ou «&nbsp;nous&nbsp;».
        OTRA GAMING est exploitée sous le régime de la micro-entreprise.
      </p>

      <h2>3. Définitions</h2>
      <p>Dans les présentes CGV, les termes suivants ont la signification suivante&nbsp;:</p>
      <ul>
        <li><strong>Utilisateur</strong> : toute personne qui consulte le site ou utilise les services OTRAQUIZZ.</li>
        <li><strong>Client</strong> : tout utilisateur qui achète un code, un pack, un accès, une participation ou tout service payant proposé sur OTRAQUIZZ.</li>
        <li><strong>Compte utilisateur</strong> : espace personnel permettant à l&apos;utilisateur d&apos;accéder à ses codes, participations, résultats, classements et éventuelles réclamations de gains.</li>
        <li><strong>Code standard</strong> : code permettant de participer à un quiz ou défi standard compatible.</li>
        <li><strong>Golden Code</strong> : code permettant de participer à un Golden Quizz ou à un défi spécifique réservé aux Golden Codes.</li>
        <li><strong>Code événement live</strong> : code ou lien permettant de rejoindre un événement live, en salle ou à distance.</li>
        <li><strong>Défi</strong> : quiz ou série de quiz proposé sur OTRAQUIZZ, avec ou sans cagnotte.</li>
        <li><strong>Événement live</strong> : animation quiz organisée en direct, en salle ou à distance, avec questions synchronisées par un animateur ou administrateur.</li>
        <li><strong>Cagnotte / gain / récompense</strong> : montant, lot ou avantage éventuellement attribué aux participants gagnants selon les règles du défi ou de l&apos;événement.</li>
      </ul>

      <h2>4. Conditions d&apos;âge</h2>
      <p>
        L&apos;achat de codes, la participation à un défi payant, la participation à un
        événement payant, l&apos;accès à un défi comportant une cagnotte ou une récompense,
        ainsi que la réclamation d&apos;un gain sont <strong>strictement réservés aux
        personnes âgées de 18 ans minimum</strong>.
      </p>
      <p>
        En passant commande sur OTRAQUIZZ, le Client déclare être majeur et avoir au
        moins 18 ans. OTRA GAMING se réserve le droit de demander tout justificatif
        permettant de vérifier l&apos;âge du Client, notamment en cas de réclamation de
        gain, de suspicion de fraude ou de contestation.
      </p>
      <p>
        Si OTRA GAMING constate qu&apos;un Client mineur a acheté un code, participé à
        un service réservé aux majeurs ou réclamé un gain, OTRA GAMING pourra
        notamment&nbsp;:
      </p>
      <ul>
        <li>suspendre ou supprimer le compte concerné&nbsp;;</li>
        <li>annuler la participation&nbsp;;</li>
        <li>annuler le score&nbsp;;</li>
        <li>refuser ou annuler le gain éventuel&nbsp;;</li>
        <li>prendre toute mesure nécessaire pour respecter la réglementation applicable.</li>
      </ul>

      <h2>5. Description des produits et services vendus</h2>
      <p>OTRAQUIZZ propose notamment à la vente&nbsp;:</p>
      <ul>
        <li>des codes standards&nbsp;;</li>
        <li>des packs de codes standards&nbsp;;</li>
        <li>des Golden Codes&nbsp;;</li>
        <li>des packs incluant des codes standards et Golden Codes&nbsp;;</li>
        <li>des accès à des défis ou quiz payants&nbsp;;</li>
        <li>des accès à des événements live&nbsp;;</li>
        <li>des codes promotionnels ou manuels lorsque ceux-ci sont proposés par l&apos;administrateur.</li>
      </ul>
      <p>Les produits et services proposés peuvent évoluer à tout moment.</p>
      <p>Les caractéristiques essentielles des produits ou services sont présentées sur le site avant la commande, notamment&nbsp;:</p>
      <ul>
        <li>le type de code&nbsp;;</li>
        <li>le nombre de codes inclus&nbsp;;</li>
        <li>le prix&nbsp;;</li>
        <li>les conditions d&apos;utilisation&nbsp;;</li>
        <li>les éventuelles restrictions&nbsp;;</li>
        <li>la compatibilité avec certains défis ou événements.</li>
      </ul>

      <h2>6. Offres et packs</h2>
      <p>OTRAQUIZZ peut proposer différents produits ou packs, par exemple&nbsp;:</p>
      <ul>
        <li><strong>Code Standard</strong> : 1 code standard&nbsp;;</li>
        <li><strong>Pack Découverte</strong> : plusieurs codes standards, avec éventuels codes bonus selon l&apos;offre en vigueur&nbsp;;</li>
        <li><strong>Golden Code</strong> : 1 code permettant l&apos;accès à un Golden Quizz&nbsp;;</li>
        <li><strong>Pack Champion</strong> : pack comprenant plusieurs codes standards et éventuellement un ou plusieurs Golden Codes.</li>
      </ul>
      <p>
        Les compositions exactes des packs, les prix et les éventuelles offres
        promotionnelles sont ceux affichés sur le site au moment de la commande.
        OTRA GAMING se réserve le droit de modifier, ajouter ou retirer des offres à
        tout moment, sans incidence sur les commandes déjà validées.
      </p>

      <h2>7. Offre pré-ouverture ou promotionnelle</h2>
      <p>OTRA GAMING peut proposer des offres temporaires, notamment dans le cadre d&apos;une période de pré-ouverture ou de lancement.</p>
      <p>Lorsqu&apos;une offre est limitée dans le temps, ses conditions sont affichées sur le site, notamment&nbsp;:</p>
      <ul>
        <li>la période de validité&nbsp;;</li>
        <li>le nombre de codes inclus&nbsp;;</li>
        <li>les éventuels codes bonus&nbsp;;</li>
        <li>le prix&nbsp;;</li>
        <li>les restrictions applicables.</li>
      </ul>
      <p>
        À l&apos;expiration de l&apos;offre, les conditions habituelles s&apos;appliquent
        automatiquement. Les codes achetés pendant une période de pré-ouverture peuvent
        être utilisables à compter de l&apos;ouverture effective des défis concernés,
        selon les informations affichées sur le site.
      </p>

      <h2>8. Prix</h2>
      <p>Les prix sont indiqués en euros. Les prix applicables sont ceux affichés sur le site au moment de la commande.</p>
      <p>Les prix peuvent être modifiés à tout moment par OTRA GAMING, sans incidence sur les commandes déjà confirmées. Le prix total est indiqué au Client avant validation définitive de la commande.</p>
      <p>
        OTRA GAMING étant exploitée sous le régime de la micro-entreprise, les prix sont
        indiqués sans TVA. <strong>TVA non applicable, article 293 B du Code général des
        impôts.</strong>
      </p>

      <h2>9. Création de compte obligatoire</h2>
      <p>L&apos;achat de codes et l&apos;utilisation des services payants nécessitent la création ou la connexion à un compte utilisateur.</p>
      <p>Le Client doit fournir des informations exactes, complètes et à jour. Le Client est responsable de la confidentialité de ses identifiants de connexion. Toute commande passée depuis le compte du Client est réputée effectuée par lui, sauf preuve contraire.</p>

      <h2>10. Processus de commande</h2>
      <p>Pour passer commande, le Client doit&nbsp;:</p>
      <ul>
        <li>se connecter ou créer un compte&nbsp;;</li>
        <li>sélectionner le produit, code, pack ou accès souhaité&nbsp;;</li>
        <li>vérifier le récapitulatif de commande&nbsp;;</li>
        <li>accepter les présentes CGV&nbsp;;</li>
        <li>procéder au paiement via le prestataire de paiement proposé&nbsp;;</li>
        <li>recevoir la confirmation de paiement&nbsp;;</li>
        <li>retrouver les codes achetés dans son espace personnel, notamment dans la rubrique «&nbsp;Mes codes&nbsp;».</li>
      </ul>
      <p>Avant validation du paiement, le Client peut vérifier le détail de sa commande et corriger d&apos;éventuelles erreurs. La commande devient définitive après confirmation du paiement par le prestataire de paiement.</p>

      <h2>11. Paiement</h2>
      <p>Le paiement est effectué en ligne par carte bancaire ou tout autre moyen de paiement proposé sur le site.</p>
      <p>Le paiement est traité par un prestataire de paiement sécurisé, notamment Stripe. OTRA GAMING ne stocke pas les informations complètes de carte bancaire du Client.</p>
      <p>La commande n&apos;est validée qu&apos;après confirmation effective du paiement. En cas de refus de paiement, d&apos;échec de paiement, d&apos;annulation ou de suspicion de fraude, la commande peut être annulée automatiquement.</p>

      <h2>12. Livraison des codes</h2>
      <p>Les codes achetés sont livrés sous forme numérique. Ils sont mis à disposition dans l&apos;espace personnel du Client, notamment dans la rubrique <strong>Mes codes</strong>.</p>
      <p>La livraison intervient normalement immédiatement après validation du paiement. En cas de délai technique, incident de paiement ou problème de synchronisation, la livraison peut être différée.</p>
      <p>Si le Client constate que ses codes n&apos;apparaissent pas après paiement confirmé, il peut contacter OTRA GAMING à l&apos;adresse suivante&nbsp;: <a href="mailto:otragaming@outlook.fr">otragaming@outlook.fr</a>.</p>

      <h2>13. Utilisation des codes</h2>
      <p>Chaque code permet d&apos;accéder au service correspondant à sa catégorie.</p>
      <ul>
        <li>Les codes standards permettent d&apos;accéder aux quiz ou défis standards compatibles.</li>
        <li>Les Golden Codes permettent d&apos;accéder aux Golden Quizz ou défis réservés aux Golden Codes.</li>
        <li>Les codes événement live permettent de rejoindre l&apos;événement live concerné.</li>
      </ul>
      <p>Un code peut avoir différents statuts, notamment&nbsp;: disponible&nbsp;; réservé&nbsp;; utilisé&nbsp;; consommé&nbsp;; expiré&nbsp;; annulé&nbsp;; remboursé.</p>
      <p>Un code utilisé, consommé, expiré ou réservé ne peut pas être réutilisé, sauf décision exceptionnelle d&apos;OTRA GAMING.</p>

      <h2>14. Réservation d&apos;un code pour un défi à venir</h2>
      <p>Le Client peut, lorsque la fonctionnalité est disponible, réserver un code pour un défi à venir.</p>
      <p>Lorsqu&apos;un code est réservé pour un défi à venir&nbsp;:</p>
      <ul>
        <li>le code est associé au défi choisi&nbsp;;</li>
        <li>il ne peut plus être utilisé librement sur un autre défi&nbsp;;</li>
        <li>il garantit la participation du Client au défi concerné selon les conditions affichées&nbsp;;</li>
        <li>il peut être comptabilisé dans l&apos;organisation du défi ou de la cagnotte.</li>
      </ul>
      <p>Si le Client ne participe pas au défi pendant la période d&apos;ouverture, le code réservé peut être considéré comme expiré ou non utilisé.</p>
      <p>Le Client reconnaît qu&apos;un code réservé pour un défi à venir n&apos;est pas automatiquement récupérable ou remboursable en cas de non-participation de sa part, sauf annulation du défi par OTRA GAMING ou décision commerciale exceptionnelle.</p>

      <h2>15. Participation aux défis</h2>
      <p>Pour participer à un défi, le Client doit&nbsp;:</p>
      <ul>
        <li>disposer d&apos;un compte valide&nbsp;;</li>
        <li>avoir au moins 18 ans lorsque le défi est payant ou comporte une cagnotte&nbsp;;</li>
        <li>disposer d&apos;un pseudo valide&nbsp;;</li>
        <li>utiliser un code compatible si nécessaire&nbsp;;</li>
        <li>respecter les règles du défi&nbsp;;</li>
        <li>disposer d&apos;un appareil et d&apos;une connexion internet adaptés.</li>
      </ul>
      <p>Chaque défi peut prévoir&nbsp;: une date d&apos;ouverture&nbsp;; une date de fermeture&nbsp;; un nombre de questions&nbsp;; une durée par question&nbsp;; une cagnotte éventuelle&nbsp;; une répartition des gains&nbsp;; des règles spécifiques de classement.</p>
      <p>Le Client doit consulter les informations du défi avant de participer.</p>

      <h2>16. Événements live</h2>
      <p>OTRAQUIZZ peut proposer des événements live, organisés en salle, à distance ou dans tout lieu défini.</p>
      <p>Les événements live peuvent nécessiter&nbsp;: l&apos;achat d&apos;un accès&nbsp;; l&apos;utilisation d&apos;un code&nbsp;; une inscription préalable&nbsp;; la présence à une date et heure déterminées.</p>
      <p>Sauf indication contraire affichée pour l&apos;événement concerné, les participants peuvent rejoindre un événement live même après son démarrage.</p>
      <p>En cas d&apos;arrivée en cours d&apos;événement&nbsp;:</p>
      <ul>
        <li>le participant rejoint l&apos;événement à l&apos;étape actuellement en cours&nbsp;;</li>
        <li>il ne peut pas répondre aux questions déjà terminées&nbsp;;</li>
        <li>les questions déjà passées peuvent être comptabilisées comme non répondues ou à zéro point&nbsp;;</li>
        <li>son classement est calculé uniquement selon les réponses enregistrées à partir de son arrivée&nbsp;;</li>
        <li>il accepte que son arrivée tardive puisse réduire ses chances d&apos;obtenir un bon classement ou un gain.</li>
      </ul>
      <p>OTRA GAMING se réserve le droit de limiter ou refuser les arrivées en cours d&apos;événement pour certains événements spécifiques, notamment pour des raisons techniques, d&apos;équité, de capacité d&apos;accueil ou d&apos;organisation.</p>
      <p>Pour les événements live payants ou comportant une récompense, la participation est réservée aux personnes âgées de 18 ans minimum.</p>

      <h2>17. Classements</h2>
      <p>Les classements sont établis selon les règles affichées pour chaque défi ou événement. Les critères de classement peuvent notamment prendre en compte&nbsp;: le score&nbsp;; le nombre de bonnes réponses&nbsp;; le temps de réponse&nbsp;; la rapidité&nbsp;; les règles propres au défi&nbsp;; les éventuels critères de départage.</p>
      <p>Sauf indication contraire, lorsqu&apos;un même utilisateur participe plusieurs fois à un même défi, seul son meilleur score est retenu pour le classement récompensé. Un même utilisateur ne peut pas occuper plusieurs places gagnantes dans un même défi avec plusieurs participations.</p>

      <h2>18. Cagnottes, récompenses et gains</h2>
      <p>Certains défis ou événements peuvent prévoir une cagnotte, une récompense ou un lot. La présence d&apos;une cagnotte ou d&apos;un gain est indiquée sur la page du défi ou de l&apos;événement concerné.</p>
      <p>Les gains peuvent être répartis entre un ou plusieurs gagnants selon les règles affichées. Exemple de répartition possible&nbsp;:</p>
      <ul>
        <li>1er&nbsp;: 50&nbsp;%&nbsp;;</li>
        <li>2e&nbsp;: 30&nbsp;%&nbsp;;</li>
        <li>3e&nbsp;: 20&nbsp;%.</li>
      </ul>
      <p>Les montants, lots, pourcentages ou modalités de répartition sont ceux affichés sur le site avant la participation.</p>
      <p>Aucun gain n&apos;est définitivement acquis tant que&nbsp;: le défi n&apos;est pas terminé&nbsp;; le classement n&apos;est pas finalisé&nbsp;; les vérifications techniques et antifraude n&apos;ont pas été effectuées&nbsp;; l&apos;éligibilité du gagnant n&apos;a pas été confirmée.</p>
      <p>La réclamation d&apos;un gain est réservée aux personnes âgées de 18 ans minimum.</p>

      <h2>19. Réclamation et paiement des gains</h2>
      <p>Lorsqu&apos;un Client est éligible à un gain, il peut être invité à réclamer son gain via l&apos;interface prévue à cet effet.</p>
      <p>Pour permettre le paiement du gain, le Client devra fournir certaines informations, notamment&nbsp;:</p>
      <ul>
        <li>nom du titulaire du compte bancaire&nbsp;;</li>
        <li>IBAN&nbsp;;</li>
        <li>BIC/SWIFT optionnel&nbsp;;</li>
        <li>toute information complémentaire nécessaire au traitement du paiement.</li>
      </ul>
      <p>Les informations bancaires sont utilisées uniquement pour le traitement du gain.</p>
      <p>OTRA GAMING peut refuser, suspendre ou annuler le paiement d&apos;un gain en cas de&nbsp;: fraude&nbsp;; tentative de fraude&nbsp;; score anormal&nbsp;; utilisation abusive du service&nbsp;; compte multiple abusif&nbsp;; utilisateur mineur&nbsp;; impossibilité de vérifier l&apos;éligibilité du gagnant&nbsp;; violation des CGU ou des présentes CGV&nbsp;; utilisation d&apos;un code appartenant à un tiers&nbsp;; contestation en cours.</p>
      <p>Les délais de paiement des gains peuvent varier selon les vérifications nécessaires et les délais bancaires.</p>

      <h2>20. Droit de rétractation</h2>
      <p>Conformément aux règles applicables aux contrats conclus à distance, le consommateur dispose en principe d&apos;un délai de 14 jours pour exercer son droit de rétractation, sans avoir à motiver sa décision.</p>
      <p>Le délai court, pour les prestations de services et contenus numériques sans support matériel, à compter de la conclusion du contrat.</p>
      <p>Pour exercer son droit de rétractation, le Client peut envoyer une demande claire à l&apos;adresse suivante&nbsp;: <a href="mailto:otragaming@outlook.fr">otragaming@outlook.fr</a>.</p>
      <p>Le Client peut utiliser le modèle suivant&nbsp;:</p>
      <blockquote>
        <p><strong>Objet</strong>&nbsp;: Demande de rétractation</p>
        <p>Bonjour,<br/>
        Je vous informe exercer mon droit de rétractation concernant la commande suivante&nbsp;:</p>
        <p>Nom&nbsp;:<br/>
        Prénom&nbsp;:<br/>
        Email du compte OTRAQUIZZ&nbsp;:<br/>
        Date de commande&nbsp;:<br/>
        Produit ou pack commandé&nbsp;:<br/>
        Montant&nbsp;:<br/>
        Référence de paiement si disponible&nbsp;:</p>
        <p>Je demande le remboursement de cette commande conformément au droit de rétractation applicable.</p>
        <p>Cordialement,<br/>[Nom]</p>
      </blockquote>

      <h2>21. Limites du droit de rétractation</h2>
      <p>Le droit de rétractation ne pourra plus être exercé lorsque le service aura été pleinement exécuté avant la fin du délai de rétractation avec l&apos;accord préalable et exprès du Client et sa reconnaissance de la perte de son droit de rétractation, conformément aux exceptions prévues par le Code de la consommation.</p>
      <p>Dans le cadre d&apos;OTRAQUIZZ, cela peut notamment concerner&nbsp;:</p>
      <ul>
        <li>un code déjà utilisé pour participer à un quiz&nbsp;;</li>
        <li>un code consommé&nbsp;;</li>
        <li>un code réservé pour un défi à venir lorsque le Client a expressément demandé l&apos;exécution immédiate du service&nbsp;;</li>
        <li>une participation déjà commencée&nbsp;;</li>
        <li>un accès à un événement live déjà utilisé&nbsp;;</li>
        <li>un gain ou classement déjà traité sur la base de cette participation.</li>
      </ul>
      <p>Pour que cette limitation soit opposable, OTRA GAMING devra recueillir, lorsque cela est nécessaire, l&apos;accord exprès du Client à l&apos;exécution immédiate du service et sa reconnaissance de la perte éventuelle du droit de rétractation.</p>
      <p>Tant qu&apos;un code n&apos;a pas été utilisé, consommé ou réservé, le Client peut demander l&apos;exercice de son droit de rétractation dans le délai légal applicable.</p>

      <h2>22. Remboursements</h2>
      <p>En cas d&apos;exercice valable du droit de rétractation, OTRA GAMING remboursera le Client dans les délais légaux applicables, via le moyen de paiement utilisé lors de la commande, sauf accord contraire.</p>
      <p>Aucun remboursement automatique n&apos;est dû lorsque&nbsp;:</p>
      <ul>
        <li>le code a été utilisé&nbsp;;</li>
        <li>le code a été consommé&nbsp;;</li>
        <li>le code a été réservé pour un défi&nbsp;;</li>
        <li>le Client n&apos;a pas participé au défi malgré sa réservation&nbsp;;</li>
        <li>le Client est arrivé en retard à un événement live&nbsp;;</li>
        <li>le Client a été exclu pour fraude ou violation des règles&nbsp;;</li>
        <li>le Client a perdu ou n&apos;a pas obtenu de gain.</li>
      </ul>
      <p>OTRA GAMING peut toutefois accorder un remboursement, un remplacement de code ou un geste commercial à titre exceptionnel.</p>

      <h2>23. Annulation ou report par OTRA GAMING</h2>
      <p>OTRA GAMING se réserve le droit d&apos;annuler, reporter, suspendre ou modifier un défi ou un événement en cas de&nbsp;: bug technique&nbsp;; erreur manifeste&nbsp;; problème de paiement&nbsp;; suspicion de fraude&nbsp;; nombre insuffisant de participants&nbsp;; problème d&apos;organisation&nbsp;; incident de sécurité&nbsp;; force majeure&nbsp;; nécessité légale, administrative ou technique.</p>
      <p>En cas d&apos;annulation d&apos;un défi ou événement par OTRA GAMING, les codes concernés pourront, selon la situation, être&nbsp;: réactivés&nbsp;; remplacés&nbsp;; recrédités&nbsp;; remboursés&nbsp;; utilisables sur un autre défi.</p>
      <p>La solution retenue dépendra de la situation, du type de code, de l&apos;état du défi et des éventuelles participations déjà enregistrées.</p>

      <h2>24. Absence de garantie de gain</h2>
      <p>L&apos;achat d&apos;un code ou la participation à un défi ne garantit aucun gain.</p>
      <p>Les gains éventuels dépendent exclusivement&nbsp;: des performances du Client&nbsp;; des réponses données&nbsp;; de la rapidité&nbsp;; des règles du défi&nbsp;; du classement final&nbsp;; des vérifications antifraude.</p>
      <p><strong>OTRAQUIZZ n&apos;est pas un jeu de hasard.</strong> Les gagnants ne sont pas désignés par tirage au sort ou mécanisme aléatoire.</p>

      <h2>25. Obligations du Client</h2>
      <p>Le Client s&apos;engage à&nbsp;:</p>
      <ul>
        <li>fournir des informations exactes&nbsp;;</li>
        <li>utiliser son propre compte&nbsp;;</li>
        <li>ne pas utiliser le compte ou les codes d&apos;un tiers&nbsp;;</li>
        <li>ne pas revendre ses codes sans autorisation&nbsp;;</li>
        <li>ne pas tenter de manipuler les scores&nbsp;;</li>
        <li>ne pas utiliser de robot, script, automatisation ou méthode de triche&nbsp;;</li>
        <li>ne pas exploiter une faille technique&nbsp;;</li>
        <li>ne pas perturber le fonctionnement du site&nbsp;;</li>
        <li>respecter les CGU, les présentes CGV et les règles propres à chaque défi.</li>
      </ul>
      <p>En cas de violation, OTRA GAMING pourra prendre toute mesure utile, notamment&nbsp;: suspension du compte&nbsp;; suppression du compte&nbsp;; annulation de la commande&nbsp;; annulation d&apos;un code&nbsp;; annulation d&apos;une participation&nbsp;; annulation d&apos;un score&nbsp;; exclusion du classement&nbsp;; refus ou annulation d&apos;un gain.</p>

      <h2>26. Responsabilité du Client</h2>
      <p>Le Client est responsable&nbsp;: de son matériel&nbsp;; de sa connexion internet&nbsp;; de son navigateur&nbsp;; de ses identifiants&nbsp;; de l&apos;utilisation de son compte&nbsp;; de sa présence à l&apos;heure prévue pour les événements&nbsp;; de la bonne utilisation des codes achetés.</p>
      <p>OTRA GAMING ne peut être tenu responsable si le Client ne peut pas participer en raison&nbsp;: d&apos;une connexion internet insuffisante&nbsp;; d&apos;un appareil incompatible&nbsp;; d&apos;un navigateur obsolète&nbsp;; d&apos;une erreur de manipulation&nbsp;; d&apos;un retard du Client&nbsp;; d&apos;une absence du Client&nbsp;; d&apos;un problème relevant du Client ou d&apos;un tiers.</p>

      <h2>27. Responsabilité d&apos;OTRA GAMING</h2>
      <p>OTRA GAMING s&apos;efforce de fournir un service accessible, fonctionnel et sécurisé. Toutefois, OTRA GAMING ne garantit pas&nbsp;: l&apos;absence totale d&apos;erreur&nbsp;; l&apos;absence d&apos;interruption&nbsp;; l&apos;absence de bug&nbsp;; la compatibilité avec tous les appareils&nbsp;; l&apos;accès permanent au service.</p>
      <p>En cas de problème technique affectant un défi ou un événement, OTRA GAMING pourra prendre toute décision nécessaire pour préserver l&apos;équité, notamment&nbsp;: corriger un classement&nbsp;; annuler une participation&nbsp;; relancer un défi&nbsp;; annuler un défi&nbsp;; rembourser ou réactiver certains codes&nbsp;; suspendre temporairement le paiement d&apos;un gain.</p>

      <h2>28. Données personnelles</h2>
      <p>OTRA GAMING traite certaines données personnelles nécessaires à la gestion des commandes, comptes, codes, participations, classements, gains et demandes de support.</p>
      <p>Les données traitées peuvent notamment inclure&nbsp;: nom ou identifiant du compte&nbsp;; adresse email&nbsp;; pseudo&nbsp;; historique d&apos;achat&nbsp;; codes achetés ou utilisés&nbsp;; participations&nbsp;; scores&nbsp;; classements&nbsp;; informations nécessaires au paiement des gains&nbsp;; données techniques de sécurité.</p>
      <p>Pour plus d&apos;informations, le Client est invité à consulter la Politique de confidentialité disponible sur le site.</p>
      <p>Pour toute demande relative aux données personnelles, le Client peut écrire à&nbsp;: <a href="mailto:otragaming@outlook.fr">otragaming@outlook.fr</a>.</p>

      <h2>29. Propriété intellectuelle</h2>
      <p>Les contenus, textes, logos, interfaces, graphismes, questions, quiz, classements, bases de données et éléments composant OTRAQUIZZ sont protégés par le droit de la propriété intellectuelle.</p>
      <p>Toute reproduction, diffusion, extraction, modification ou exploitation non autorisée est interdite. L&apos;achat d&apos;un code ou la participation à un défi ne confère aucun droit de propriété sur la plateforme ou ses contenus.</p>

      <h2>30. Preuve de la transaction</h2>
      <p>Les registres informatiques, confirmations de paiement, historiques de commande, journaux techniques, données Stripe, données de compte et données de participation pourront être utilisés comme éléments de preuve en cas de litige.</p>
      <p>Le Client reconnaît que les systèmes informatiques d&apos;OTRA GAMING et de ses prestataires peuvent faire foi, sauf preuve contraire.</p>

      <h2>31. Réclamation</h2>
      <p>Pour toute réclamation, le Client peut contacter OTRA GAMING à l&apos;adresse suivante&nbsp;: <a href="mailto:otragaming@outlook.fr">otragaming@outlook.fr</a>.</p>
      <p>La réclamation doit préciser&nbsp;:</p>
      <ul>
        <li>l&apos;identité du Client&nbsp;;</li>
        <li>l&apos;adresse email du compte&nbsp;;</li>
        <li>la date de commande&nbsp;;</li>
        <li>le produit ou code concerné&nbsp;;</li>
        <li>la description du problème&nbsp;;</li>
        <li>tout justificatif utile.</li>
      </ul>
      <p>OTRA GAMING s&apos;efforcera de répondre dans un délai raisonnable.</p>

      <h2>32. Médiation de la consommation</h2>
      <p>Conformément aux articles L.612-1 et suivants du Code de la consommation, le consommateur peut recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable d&apos;un litige l&apos;opposant à OTRA GAMING, après avoir préalablement adressé une réclamation écrite à OTRA GAMING.</p>
      <p>Le consommateur doit avoir tenté de résoudre le litige directement auprès d&apos;OTRA GAMING avant de saisir le médiateur.</p>
      <p>La demande de médiation doit être introduite dans un délai d&apos;un an à compter de la réclamation écrite adressée à OTRA GAMING.</p>
      <p><strong>Médiateur désigné&nbsp;:</strong> Médiateur de la consommation en cours de désignation.</p>
      <p>OTRA GAMING est en cours de désignation d&apos;un médiateur de la consommation compétent pour son activité. Cette section sera complétée dès la signature d&apos;une convention avec un médiateur de la consommation.</p>

      <h2>33. Force majeure</h2>
      <p>OTRA GAMING ne pourra être tenu responsable en cas d&apos;inexécution ou de retard d&apos;exécution résultant d&apos;un cas de force majeure ou d&apos;un événement indépendant de sa volonté.</p>
      <p>Sont notamment concernés&nbsp;: panne majeure&nbsp;; cyberattaque&nbsp;; défaillance d&apos;un prestataire&nbsp;; interruption de réseau&nbsp;; événement climatique&nbsp;; décision administrative&nbsp;; incident bancaire&nbsp;; indisponibilité d&apos;un service tiers&nbsp;; tout événement imprévisible, irrésistible et extérieur.</p>

      <h2>34. Modification des CGV</h2>
      <p>OTRA GAMING se réserve le droit de modifier les présentes CGV à tout moment. Les CGV applicables sont celles en vigueur au moment de la commande. Les nouvelles CGV s&apos;appliquent aux commandes passées après leur publication sur le site.</p>
      <p>Le Client est invité à consulter régulièrement les CGV.</p>

      <h2>35. Nullité partielle</h2>
      <p>Si une clause des présentes CGV est déclarée nulle, illégale ou inapplicable, les autres clauses restent pleinement applicables. La clause concernée sera remplacée, dans la mesure du possible, par une clause valable ayant un effet économique ou juridique équivalent.</p>

      <h2>36. Droit applicable</h2>
      <p>Les présentes CGV sont soumises au droit français. En cas de litige, le Client est invité à contacter OTRA GAMING afin de rechercher une solution amiable.</p>
      <p>À défaut de résolution amiable ou de médiation, le litige pourra être porté devant les juridictions compétentes conformément aux règles de droit commun.</p>

      <h2>37. Contact</h2>
      <p>Pour toute question relative aux présentes CGV, à une commande, à un code ou à un remboursement, le Client peut contacter OTRA GAMING à l&apos;adresse suivante&nbsp;: <a href="mailto:otragaming@outlook.fr">otragaming@outlook.fr</a>.</p>
    </LegalPage>
  );
}
